import {
  Button,
  Chip,
  Dialog,
  Grid,
  Menu,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { Dispatch, SetStateAction, useContext, useState } from "react";

interface Props {
  anchorEl: null | HTMLElement;
  setAnchorEl: Dispatch<SetStateAction<null | HTMLElement>>;
}

const ExclusiveContact = ({ anchorEl, setAnchorEl }: Props) => {
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openDialog, setOpenDialog] = useState(false);

  const open = Boolean(anchorEl);
  const id = open ? "sourced-from-inbox" : undefined;

  const renderMenuContent = () => {
    return (
      <>
        <Grid
          container
          justifyContent={"center"}
          direction={"column"}
          sx={{
            px: 3,
            py: 2,
            maxWidth: 300,
          }}
        >
          <Grid container justifyContent={"center"} item xs={12} sx={{ mb: 1 }}>
            <Chip
              size="small"
              sx={{
                backgroundColor: "yellow.main",
                width: "max-content",
                fontWeight: 600,
                px: 1,
              }}
              label="This is an exclusive contact"
            />
          </Grid>
          <Typography textAlign={"center"}>
            Contacts that are <strong>2-3 times more likely to respond </strong>
          </Typography>

          <Button
            sx={{ mt: 1 }}
            fullWidth
            disableElevation
            variant="contained"
            onClick={() => setUpgradeDialogSource("Exclusive Contact")}
          >
            Upgrade to Email
          </Button>
        </Grid>
      </>
    );
  };

  return (
    <>
      <Button
        onClick={(e) => {
          if (isMobileScreen) {
            setOpenDialog(true);
          } else {
            setAnchorEl(e.currentTarget);
            setOpenDialog(false);
          }
        }}
        size="small"
        sx={{ textTransform: "none", fontSize: 12, color: "info.main" }}
      >
        Exclusive 💎
      </Button>
      <Menu
        id={id}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        sx={{ zIndex: 1200 }}
        onClose={() => setAnchorEl(null)}
      >
        {renderMenuContent()}
      </Menu>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        {renderMenuContent()}
      </Dialog>
    </>
  );
};

export default ExclusiveContact;
